import { Box } from '@mui/material';
import React from 'react';
import ThinkingCardImage01 from '../../assets/images/ThinkingDetailHeader.jpg'

const ThinkingDetailBgLanding = () => {
  return (
    <Box
      sx={{
        width: '100%',
        padding: {xs:"2rem 1rem",sm:"2rem 3rem"},
      }}
    >
      <Box
        sx={{
          width: '100%',
          height: {xs:"10rem",sm:"22rem"},
          marginTop:"5rem",
          overflow: 'hidden', // Ensures the image stays within the container
        }}
      >
        <img
          src={ThinkingCardImage01}
          alt=""
          style={{
            width: '100%',
            height: '100%',
            objectFit: 'cover', // Makes the image cover the entire box while keeping the aspect ratio
          }}
        />
      </Box>
    </Box>
  );
};

export default ThinkingDetailBgLanding;
